module.exports = "./img/c738f188eaaaf1eac834e6badaa88c52.png";